// src/shared/components/ui/Modal.jsx
// ✅ نافذة منبثقة موحدة — Modern Dark Ready
import React, { useEffect } from 'react';
import styles from './Modal.module.css';
import Button from './Button';

/**
 * @param {boolean}         isOpen
 * @param {Function}        onClose
 * @param {string}          title
 * @param {React.ReactNode} children
 * @param {'sm'|'md'|'lg'|'xl'} size
 * @param {React.ReactNode} footer
 */
const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size   = 'md',
  footer,
}) => {
  /* إغلاق بـ Escape */
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  /* منع التمرير خلف المودال */
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className={`${styles.content} ${styles[size]}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── الرأس ── */}
        <div className={styles.header}>
          <h2 className={styles.title} id="modal-title">{title}</h2>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="إغلاق"
            type="button"
          >
            &times;
          </button>
        </div>

        {/* ── الجسم ── */}
        <div className={styles.body}>{children}</div>

        {/* ── الفوتر ── */}
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
};

/* ── فوتر جاهز بزري إلغاء وحفظ ──────────────────────────── */
export const ModalFooter = ({
  onClose,
  onSave,
  saveLabel   = 'حفظ',
  cancelLabel = 'إلغاء',
  loading     = false,
  saveVariant = 'primary',
}) => (
  <div style={{ display: 'flex', gap: 'var(--space-3)', justifyContent: 'flex-end' }}>
    <Button
      variant="secondary"
      size="sm"
      onClick={onClose}
      disabled={loading}
      type="button"
    >
      {cancelLabel}
    </Button>
    <Button
      variant={saveVariant}
      size="sm"
      onClick={onSave}
      loading={loading}
      type="button"
    >
      {saveLabel}
    </Button>
  </div>
);

export default Modal;